import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { OverviewScreen } from "../../features/overview/overview-screen";

export function createOverviewRoute(dependencies: AdminDashboardDependencies): AdminRouteObject {
  return {
    index: true,
    element: <OverviewScreen dependencies={dependencies} />,
  };
}
